<div class="scan-barcode">
    <app-centered-scrollable-content>

      <sc-flex [vertical]="true" [centered]="true" [stretchContent]="true">
      <h2>{{'' | translate: [messageDictionaryKey, translationService.language]}}</h2>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <ng-container *ngIf="validationMessage != null">
            <h2>{{validationMessage.message | translate: [validationMessage.message, translationService.language]}}</h2>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>
        <div *ngIf="showHint">{{'' | translate: ['tmc-yard.widgets.registration-terminal.barcode-scan.hint', translationService.language]}}</div>

      </sc-flex>
    </app-centered-scrollable-content>
</div>
